import { Layout } from '@/components/forms/fields/types';
import {
  // changeMeta,
  makeLayoutOptionalExcept,
} from '@/components/forms/field.schema';
import { listFields, templateFields } from './lists.fields';

const {
  nameInEdit,
  name,
  werk_id,
  associated_users,
  start_date,
  end_date,
  template_id,
} = listFields;

// Detail layout: name only visible in edit mode (shown in panel header otherwise),
// status removed entirely (shown as badge in header, managed via entity actions).
// Activity link + dependencies are rendered by ListSummaryFooter, not the form.
export const checklistDetailLayout = {
  '': {
    //name: changeMeta(name, { visibleIn: ['edit'] }),
    name: nameInEdit,
    werk_id,
    associated_users,
  },
  Planning: {
    start_date,
    end_date,
  },
  // Metadata: {
  //   created,
  //   modified,
  // },
} satisfies Layout;

// Create layout: status is always "open" and werk_id comes from route context,
// so neither needs to be shown to the user.
// `template_id` is included so users can seed the new checklist from an existing
// template via EXPAND_PROTO; selecting "blank" leaves it null and skips the event.
export const createChecklistLayout = makeLayoutOptionalExcept(
  {
    '': {
      name,
      template_id,
      associated_users,
    },
    Planning: {
      start_date,
      end_date,
    },
  },
  ['name'],
);

/**
 * Detail layout for template panel.
 * Name is only shown in edit mode (panel header shows it in view mode).
 * Tags are always editable. Status/werk_id are not relevant for templates.
 */
export const templateDetailLayout = {
  '': {
    name: templateFields.nameInEdit,
    tags: templateFields.tags,
  },
} satisfies Layout;

/**
 * Create layout for the "new template" panel.
 * Only name is required; tags are optional.
 */
export const templateCreateLayout = makeLayoutOptionalExcept(
  {
    '': {
      name: templateFields.name,
      tags: templateFields.tags,
    },
  },
  ['name'],
);
